// Тот же тестовый сайт, для которого в кабинете включаются веб-пуши.
export const PIPELINE_TEST_SITE_ID = '69b968fee03c8ac83206e0eb'

export function isLocalCabinet() {
  if (process.env.NODE_ENV === 'development') return true
  if (typeof window === 'undefined') return false
  const host = window.location.hostname
  return host === 'localhost' || host === '127.0.0.1' || host === '[::1]'
}

export function isRfmAvailable(siteId) {
  return isLocalCabinet() || siteId === PIPELINE_TEST_SITE_ID
}



// WEBPACK FOOTER //
// ./src/components/instruments/pipeline/testSite.js